import { Heading } from "@chakra-ui/react";
import React from "react";

const PageHeading = ({ children }) => {
    return (
        <Heading
            as="h2"
            size={["lg", "lg", "xl"]}
            className="text-primary-color-500 mb-4"
        >
            {children}
        </Heading>
    );
};

export default PageHeading;
